/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auditor_ProjectsInputs */

const en_auditor_projects = /** @type {(inputs: Auditor_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Projects`)
};

const nl_auditor_projects = /** @type {(inputs: Auditor_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Projecten`)
};

/**
* | output |
* | --- |
* | "Audit Projects" |
*
* @param {Auditor_ProjectsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const auditor_projects = /** @type {((inputs?: Auditor_ProjectsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auditor_ProjectsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_auditor_projects(inputs)
	return en_auditor_projects(inputs)
});